import { GridPaginationModel } from '@mui/x-data-grid';

export type ServerPagedResult<T> = {
	items: T[];
	hasNextPage: boolean;
};

export function getServerGridRowCount<T>(data: ServerPagedResult<T> | undefined, paginationModel: GridPaginationModel): number {
	return data ? paginationModel.page * paginationModel.pageSize + (data.hasNextPage ? paginationModel.pageSize + 1 : data.items.length) : 0;
}
